import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import { GameLogic } from '../../../Logic/GameLogic';
import { AnimationContents } from '../../../../AnimationContents';
import { ManDragonBonesController } from './ManDragonBonesController';
import { UnitModel } from '../../../Models/Game/UnitModel';
import { WomanDragonBonesController } from './WomanDragonBonesController';

export interface IUnitControllerOptions {}

export class UnitController extends AnimationBaseController {
    $model: UnitModel;

    public constructor(
        @Inject private _options: IUnitControllerOptions,
        @Inject private _gameLogic: GameLogic
    ) {
        super('UnitController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.GAME_SCREEN_JSON,
            libraryName: 'unit_container',
            childControllers: {
                // Unit2Controller:{
                //     instanceName: "unit",
                //     view: Unit2Controller,
                //     model: this.$model
                // }
                animation: {
                    view: this._gameLogic.isWoman()
                        ? WomanDragonBonesController
                        : ManDragonBonesController,
                    model: this.$model,
                },
            },
            modelWatch: {
                // "move": (move:[number,number]) => {
                //     if(move[0] < 0){
                //         this.scaleX = -1;
                //     }else if(move[0] > 0) {
                //         this.scaleX = 1;
                //     }
                //
                //     // if(move[0] != 0 || move[1] != 0){
                //     //     this.walk();
                //     // }else {
                //     //     this.idle();
                //     // }
                // },
                pos: (pos: [number, number]) => {
                  this.updatePos(pos);
                },
                name: (name: string) => {
                    this.setTextByQuery('player_name', `${this.$model.name}`);
                },
                visible: (visible: boolean) => {
                    this.visible = visible;
                },
            },
            queue: {},
        };
    }

    protected onInitialize(): void {
        this.x = this.$model.pos[0];
        this.y = this.$model.pos[1];

        this.visible = this.$model.visible;

        this.display.hitArea = new PIXI.Rectangle(-50, -200, 100, 250);

        this.setTextByQuery('player_name', '');
        this.setScaleByQuery('dummy', 0, 0);

        const dummy = this.getDisplayObjectByQuery('unit')[0];
        dummy.visible = false;

        this.updatePos(this.$model.pos)
    }

    private updatePos(pos: [number, number]): void {
        this.x = pos[0];
        this.y = pos[1];

        const global = this.display.parent.toGlobal(
            new PIXI.Point(this.x, this.y)
        );

        if (
            global.x !== this.$model.screenPos[0] ||
            global.y !== this.$model.screenPos[1]
        ) {
            this.$model.screenPos = [global.x, global.y];
        }
    }

    private _stop() {
        this._progress = 1;
    }

    private _progress: number = 1;
    private _speed: number = 0;
    private _moveToX: number = 0;
    private _oldX: number = 0;
    private _oldY: number = 0;
    private _moveToY: number = 0;

    protected onUpdate(frameRate: number) {
        if (this._progress < 1) {
            this._progress += frameRate * this._speed;
            if (this._progress >= 1) {
                this._progress = 1;
            }

            this.x = this._oldX + this._moveToX * this._progress;
            this.y = this._oldY + this._moveToY * this._progress;
            if (this.onMove) {
                this.onMove(this.x, this.y);
            }
        }
    }

    public onMove: (x: number, y: number) => void;

    public moveTo(x: number, y: number) {
        this._oldX = this.x;
        this._moveToX = x - this.x;
        this._oldY = this.y;
        this._moveToY = y - this.y;
        this._progress = 0;
        this._speed = 100 / 10;
    }
}
